<template>
  <div>
    <!-- 搜索和筛选区域 -->
    <div class="container-block" style="margin: 15px 0">
      <a-form-model layout="inline">
        <a-form-model-item label="配方:">
          <a-input style="width: 200px" placeholder="输入配方名称/代码" @pressEnter="getList(search)"
            v-model="search.formulaKeyword" />
        </a-form-model-item>
        <a-form-model-item label="动物类型:">
          <animal-select style="width: 200px" @change="anmimlChange" :val="animal" />
        </a-form-model-item>
        <a-form-model-item label="状态:">
          <a-select style="width: 200px" v-model="search.auditStatus" placeholder="选择配方状态" allow-clear>
            <a-select-option value="0">新建</a-select-option>
            <a-select-option value="1">已测算</a-select-option>
            <a-select-option value="86">待审核</a-select-option>
            <a-select-option value="3">审核通过</a-select-option>
            <a-select-option value="4">审核撤销</a-select-option>
            <a-select-option value="5">编辑中</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="显示与隐藏:">
          <a-select style="width: 200px" v-model="search.status" placeholder="显示" allow-clear>
            <a-select-option :value="0">显示</a-select-option>
            <a-select-option :value="1">隐藏</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <a-button type="primary" @click="() => getList(search)">查询</a-button>
            <a-button @click="resetList">清空</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </div>

    <!-- 操作按钮区域 -->
    <div class="editBox">
      <a-button v-if="btnCanShow('addOEMFormula')" type="primary" @click="addRow">新建</a-button>
      <a-button v-if="btnCanShow('deleteOEMFormulas')" ghost type="danger" :disabled="isDelete" @click="deleteRow">批量删除</a-button>
      <a-button v-if="btnCanShow('batchSubmitReview')" :disabled="isBatchSubmitDisabled" @click="batchSubmitForReview">批量送审</a-button>
      <a-button v-if="btnCanShow('batchReview')" :disabled="isBatchReviewDisabled" @click="batchReview">批量审核</a-button>
      <a-button :class="{ enable: selectedRowKeys.length > 0 }" :disabled="selectedRowKeys.length === 0" @click="updateStatus('show')">显示</a-button>
      <a-button :class="{ forbidden: selectedRowKeys.length > 0 }" :disabled="selectedRowKeys.length === 0" @click="updateStatus('hide')">隐藏</a-button>
      <template v-if="selectedRowKeys.length > 0">
        <a-tag> 已选择 {{ selectedRowKeys.length }} 项目 </a-tag>
      </template>
    </div>

    <!-- 数据表格 -->
    <a-table :columns="columns" :loading="oemLoading" :data-source="list.records"
      :row-selection="{ selectedRowKeys, onChange: onSelectChange, getCheckboxProps }" row-key="id"
      :pagination="pagination" class="tableBox">
      <a-tooltip slot="formulaName" slot-scope="text, record">
        <template slot="title">
          {{ text }}
        </template>
        <a @click="goEditor(record)">{{ text }}</a>
      </a-tooltip>

      <template slot="auditStatus" slot-scope="text">
        <span :style="{ color: getStatusColor(text) }">{{ getStatusText(text) }}</span>
      </template>

      <template slot="formulaType" slot-scope="text">
        <span>{{ getFormulaTypeText(text) }}</span>
      </template>

      <template slot="operation" slot-scope="text, record">
        <a @click="goEditor(record)">配方设计</a>
        <a-divider type="vertical" />
        <a @click="copyRow(record)">复制</a>
        <!-- <a-divider v-if="record.auditStatus === 2" type="vertical" />
        <a v-if="record.auditStatus === 2" @click="reviewRow(record)">审核</a> -->
      </template>
    </a-table>

    <!-- 模态框 -->
    <o-e-m-create-modal :show="oemCreateVisible" :mode="modalMode" :copyData="rowData" @close="closeOEMCreate" />

    <!-- 批量审核弹窗 -->
    <a-modal title="批量审核" :visible="batchReviewVisible" @ok="confirmBatchReview" @cancel="cancelBatchReview" okText="确定"
      cancelText="取消">
      <a-form-model layout="vertical">
        <a-form-model-item style="margin-bottom: 8px;">
          <span style="margin-right: 8px;">选中配方:</span>
          {{ getSelectedFormulaNames() }}
        </a-form-model-item>
        <a-form-model-item label="审核结果" style="margin-bottom: 0;">
          <a-radio-group v-model="auditStatus">
            <a-radio :value="3"><span :style="{ color: getStatusColor(3) }">审核通过</span></a-radio>
            <a-radio :value="4"><span :style="{ color: getStatusColor(4) }">审核撤销</span></a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { nhfMixins } from "../untils";
import { mapActions, mapState } from 'vuex';
import OEMCreateModal from './modal/OEMCreateModal.vue'
import AnimalSelect from '../Compound/select/AnimalSelect.vue'
import api from './api'


export default {
  name: 'OEM',
  components: { OEMCreateModal, AnimalSelect },
  mixins: [nhfMixins],
  data() {
    return {
      buttonList: [],
      animal: [],

      search: {
        formulaKeyword: '',
        animalTypeCode: undefined,
        auditStatus: undefined,
        status: 0
      },
      columns: [
        {
          title: "配方名称",
          dataIndex: "formulaName",
          scopedSlots: { customRender: "formulaName" },
          width: 140,
          ellipsis: true,
        },
        {
          title: "代码",
          dataIndex: "formulaCode",
          width: 120,
          ellipsis: true,
        },
        {
          title: "分类",
          dataIndex: "formulaType",
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "formulaType" },
        },
        {
          title: "动物类型",
          dataIndex: "animalTypeName",
          width: 100,
          ellipsis: true,
        },
        {
          title: "工厂名称",
          dataIndex: "factoryName",
          width: 120,
          ellipsis: true,
        },
        {
          title: "备注",
          dataIndex: "remark",
          width: 100,
          ellipsis: true,
        },
        {
          title: "创建用户",
          dataIndex: "createUserName",
          width: 100,
          ellipsis: true,
        },
        {
          title: "编辑用户",
          dataIndex: "updateUserName",
          width: 100,
          ellipsis: true,
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          width: 180,
          ellipsis: true,
          sorter: (a, b) => {
            const timeA = a?.createTime;
            const timeB = b?.createTime;
            // 处理空值：空值排在最后
            if (!timeA && !timeB) return 0;
            if (!timeA) return 1;
            if (!timeB) return -1;
            // 使用Date对象进行比较，更可靠
            const dateA = new Date(timeA);
            const dateB = new Date(timeB);
            // 如果日期有效，使用时间戳比较
            if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
              return dateA.getTime() - dateB.getTime();
            }
            // 如果日期无效，使用字符串比较作为后备方案
            return String(timeA || '').localeCompare(String(timeB || ''));
          },
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: "编辑时间",
          dataIndex: "updateTime",
          width: 180,
          ellipsis: true,
          sorter: (a, b) => {
            const timeA = a?.updateTime;
            const timeB = b?.updateTime;
            // 处理空值：空值排在最后
            if (!timeA && !timeB) return 0;
            if (!timeA) return 1;
            if (!timeB) return -1;
            // 使用Date对象进行比较，更可靠
            const dateA = new Date(timeA);
            const dateB = new Date(timeB);
            // 如果日期有效，使用时间戳比较
            if (!isNaN(dateA.getTime()) && !isNaN(dateB.getTime())) {
              return dateA.getTime() - dateB.getTime();
            }
            // 如果日期无效，使用字符串比较作为后备方案
            return String(timeA || '').localeCompare(String(timeB || ''));
          },
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: "状态",
          dataIndex: "auditStatus",
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: "auditStatus" },
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: 200,
          align: "center",
          scopedSlots: { customRender: "operation" },
        },
      ],
      oemLoading: false,
      formulaId: '',
      addVisible: false,
      oemCreateVisible: false,
      modalMode: 'create', // 'create' 或 'copy'
      rowData: {},
      factoryId: window.localStorage.getItem('factoryId') || 'factory001',
      selectedRowKeys: [],
      selectedRows: [],
      list: {
        records: [],
        total: 0,
        current: 1,
        size: 20
      },
      // 分页配置
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: false,
        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条/共 ${total} 条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.pagination.pageSize = pageSize;
          this.getList({ current, size: pageSize, ...this.search });
        },
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize;
          this.pagination.current = 1;
          // 保存页面大小到本地存储
          window.localStorage.setItem('oemSize', pageSize);
          this.getList({ current: 1, size: pageSize, ...this.search });
        }
      },
      // 批量审核相关
      batchReviewVisible: false,
      auditStatus: 3 // 默认选中审核通过
    }
  },
  computed: {
    ...mapState('home', ['btnList']),

    isDelete() {
      // 检查选中配方数量
      if (this.selectedRowKeys.length === 0) {
        return true;
      }
      
      // 检查选中配方数量是否超过20
      if (this.selectedRowKeys.length > 20) {
        return true;
      }
      
      // 检查被选中配方中是否有审核通过或待审核状态的配方
      // 如果有任何配方是审核通过(3)或待审核(86)状态，则禁用删除按钮
      const hasApprovedOrPending = this.selectedRows.some(row => 
        row.auditStatus === 3 || row.auditStatus === 86
      );
      
      // 如果有审核通过或待审核的配方，则禁用删除按钮
      return hasApprovedOrPending;
    },
    
    // 批量送审按钮禁用条件：选中配方数量 != 0，且选中配方状态都==已测算
    isBatchSubmitDisabled() {
      // 检查选中配方数量
      if (this.selectedRowKeys.length === 0) {
        return true;
      }
      
      // 检查所有选中的配方状态是否都等于已测算(1)
      const allCalculated = this.selectedRows.every(row => row.auditStatus === 1);
      
      // 只有当所有选中的配方都是已测算状态时，才允许批量送审
      return !allCalculated;
    },
    
    // 批量审核按钮禁用条件：选中数量>0并且<=20，且有选中配方的配方状态==待审核
    isBatchReviewDisabled() {
      // 检查选中配方数量
      if (this.selectedRowKeys.length === 0 || this.selectedRowKeys.length > 20) {
        return true;
      }
      
      // 检查是否有选中的配方状态为待审核(86)
      const hasPendingReview = this.selectedRows.some(row => row.auditStatus === 86);
      
      // 只有当有配方是待审核状态时，才允许批量审核
      return !hasPendingReview;
    }
  },
  watch: {
    btnList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.buttonList = newVal.find(el => el.code === 'OEM-formula').children || [];
        }
      }
    }
  },
  created() {
    // 从本地存储恢复页面大小设置
    const savedSize = window.localStorage.getItem('oemSize')
    if (savedSize) {
      this.pagination.pageSize = parseInt(savedSize)
      this.list.size = parseInt(savedSize)
    }
    this.getList();
    this.initButtonList();
  },
  methods: {
    ...mapActions('nhf', ['setOemFormulaData']),

    /**
     * 初始化按钮列表
     * 从store中获取按钮权限列表并设置当前组件的按钮列表
     */
    initButtonList(){
    if (this.btnList.length > 0) {
      this.buttonList = this.btnList.find(el => el.code === 'OEM-formula').children || [];
    }
    },

    /**
     * 判断按钮是否显示
     * @param {string} path - 按钮路径
     * @returns {boolean} 是否显示按钮
     */
    btnCanShow(path) {
      return this.buttonList.some(el => el.path === path);
    },

    /**
     * 获取OEM配方列表
     * @param {Object} arg - 查询参数
     * @param {number} arg.current - 当前页码
     * @param {number} arg.size - 每页大小
     */
    async getList(arg = {}) {
      let { current, size, pageSize } = arg || {}
      // 统一使用 size 作为每页条数参数，默认取当前分页配置
      if (!current) current = this.pagination.current || 1
      if (!size) size = pageSize || this.pagination.pageSize || 10
      
      this.oemLoading = true;
      
      try {
        // 调用实际的API接口
        const res = await api.getOEMFormulaPage({
          query: {
            current,
            size,
          },
          factoryId: this.factoryId,
          formulaType: 5,
          ...this.search
        })
        
        if (res && res.success) {
          this.list = res.data
          // 更新分页信息
          this.pagination.current = res.data.current || 1
          this.pagination.pageSize = res.data.size || 10
          this.pagination.total = res.data.total || 0
        }
      } catch (error) {
        console.error('获取OEM配方列表失败:', error)
        this.$message.error('获取配方列表失败')
      } finally {
        this.oemLoading = false;
      }
    },
    
    /**
     * 重置搜索条件并重新获取列表
     */
    resetList() {
      this.search = {
        formulaKeyword: '',
        animalTypeCode: undefined,
        auditStatus: undefined,
        status: 0
      };
      this.animal = [];
      this.getList(this.search);
    },
    

    
    /**
     * 动物类型选择改变事件处理
     * @param {Array} val - 选中的动物类型代码数组
     */
     anmimlChange(val) {
      this.animal = val;
      // 取最后一个值作为动物类型代码
      this.search.animalTypeCode = val && val.length > 0 ? val[val.length - 1] : undefined;
    },
    
    /**
     * 表格行选择改变事件处理
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    
    /**
     * 获取表格复选框属性
     * @param {Object} record - 表格行数据
     * @returns {Object} 复选框属性
     */
    getCheckboxProps(record) {
      return {
        disabled: record.auditStatus === 3 || record.auditStatus === 4,
      };
    },
    
    /**
     * 跳转到配方设计页面
     * @param {Object} record - 配方记录
     */
    goEditor(record) {
      this.setOemFormulaData(record);
      // 跳转到配方设计页面
      this.$router.push({
        name: 'OEMFormulaDesign',
        query: { id: record.id }
      });
    },
    
    /**
     * 添加新配方
     */
    addRow() {
      this.modalMode = 'create'
      this.oemCreateVisible = true
    },
    
    /**
     * 删除配方的API函数
     */
    async removeFormulaIds(data) {
      const { post } = await import('@/Utils/axios');
      return post('/nhf-app/formulaManage/removeFormulaIds', data);
    },
    
    /**
     * 删除选中的配方
     */
    async deleteRow() {
      this.$confirm({
        title: "提示",
        content: "确定将选中的配方删除吗？",
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          try {
            // 调用删除API，参数为ids，内容为每一行的id用逗号分隔
            const res = await this.removeFormulaIds({
              ids: this.selectedRowKeys.join(',')
            })
            
            // 检查响应结果
            if (res && res.success) {
              // 删除成功
              this.$message.success(res.msg || '删除成功');
              this.cleanSelect();
              this.getList(this.search);
            } else {
              // 删除失败，显示后台返回的错误信息
              const errorMsg = res?.msg || '删除失败';
              this.$message.error(errorMsg);
              
              // 如果是业务逻辑错误（如有关联产品），可以选择是否刷新列表
              if (res?.code === 400) {
                // 刷新列表以显示最新状态
                this.getList(this.search);
              }
            }
          } catch (error) {
            console.error('删除配方失败:', error);
            // 显示具体的错误信息
            const errorMsg = error?.msg || error?.message || '删除失败，请稍后重试';
            this.$message.error(errorMsg);
          }
        }
      })
    },
    
    /**
     * 批量送审配方
     */
    async batchSubmitForReview() {
      this.$confirm({
        title: "提示",
        content: "确认将选中的配方批量送审吗？",
        okText: "继续",
        cancelText: "取消",
        onOk: async () => {
          try {
            // 调用批量送审API
            const res = await api.batchSubmitForReview({
              idList: this.selectedRowKeys,
              auditStatus: 86
            })
            
            if (res && res.success) {
              this.$message.success(res.msg || '批量送审成功');
              this.cleanSelect();
              this.getList(this.search);
            } else {
              // 送审失败，显示后台返回的错误信息
              const errorMsg = res?.msg || '批量送审失败';
              this.$message.error(errorMsg);
            }
          } catch (error) {
            console.error('批量送审失败:', error);
            const errorMsg = error?.msg || error?.message || '批量送审失败，请稍后重试';
            this.$message.error(errorMsg);
          }
        }
      })
    },
    
    /**
     * 打开批量审核弹窗
     */
    batchReview() {
      // 重置审核状态为默认值
      this.auditStatus = 3;
      // 打开批量审核弹窗
      this.batchReviewVisible = true;
    },
    
    /**
     * 确认批量审核
     */
    async confirmBatchReview() {
      try {
        // 调用批量审核API
        const res = await api.batchAudit({
          idList: this.selectedRowKeys,
          auditStatus: this.auditStatus
        })
        
        if (res && res.success) {
          this.$message.success(res.msg || '批量审核成功');
          this.cleanSelect();
          this.getList(this.search);
          this.batchReviewVisible = false;
        } else {
          // 审核失败，显示后台返回的错误信息
          const errorMsg = res?.msg || '批量审核失败';
          this.$message.error(errorMsg);
        }
      } catch (error) {
        console.error('批量审核失败:', error);
        const errorMsg = error?.msg || error?.message || '批量审核失败，请稍后重试';
        this.$message.error(errorMsg);
      }
    },
    
    /**
     * 取消批量审核
     */
    cancelBatchReview() {
      this.batchReviewVisible = false;
    },
    
    /**
     * 更新配方状态（显示/隐藏）
     * @param {string} type - 'show' 或 'hide'
     */
    async updateStatus(type) {
      this.$confirm({
        title: "提示",
        content: type === 'show' ? "确认显示选中的配方吗？" : '确认隐藏选中的配方吗？',
        okText: "继续",
        cancelText: "取消",
        onOk: async () => {
          try {
            const data = {
              ids: this.selectedRowKeys.join(','),
              status: type === 'show' ? 0 : 1
            };
            const res = await api.batchUpdateFormulaStatus(data);
            if (res && res.success) {
              this.$message.success(res.msg || (type === 'show' ? '显示成功' : '隐藏成功'));
              this.cleanSelect();
              this.getList(this.search);
            } else {
              const errorMsg = res?.msg || (type === 'show' ? '显示失败' : '隐藏失败');
              this.$message.error(errorMsg);
            }
          } catch (error) {
            console.error('更新状态失败:', error);
            const errorMsg = error?.msg || error?.message || '操作失败，请稍后重试';
            this.$message.error(errorMsg);
          }
        }
      });
    },
    
    /**
     * 复制配方
     * @param {Object} record - 要复制的配方记录
     */
    copyRow(record) {
      this.rowData = { ...record }
      this.modalMode = 'copy'
      this.oemCreateVisible = true
    },
    
    /**
     * 审核单个配方
     * @param {Object} record - 要审核的配方记录
     */
    async reviewRow(record) {
      this.$confirm({
        title: "提示",
        content: "确认审核通过该配方吗？",
        okText: "通过",
        cancelText: "取消",
        onOk: async () => {
          try {
            // 调用单个审核API
            const res = await api.audit({
              id: record.id,
              auditStatus: 3
            })
            
            if (res && res.success) {
              this.$message.success(res.msg || '审核成功');
              this.getList(this.search);
            } else {
              // 审核失败，显示后台返回的错误信息
              const errorMsg = res?.msg || '审核失败';
              this.$message.error(errorMsg);
            }
          } catch (error) {
            console.error('审核失败:', error);
            const errorMsg = error?.msg || error?.message || '审核失败，请稍后重试';
            this.$message.error(errorMsg);
          }
        }
      })
    },
    
    /**
     * 关闭添加弹窗
     * @param {boolean} type - 是否成功添加
     */
    closeAdd(type) {
      if (type) {
        this.$message.success('新建成功');
        this.getList();
      }
      this.addVisible = false
    },
    
    /**
     * 关闭OEM创建弹窗
     * @param {boolean} type - 是否成功创建
     */
    closeOEMCreate(type) {
      if (type) {
        const message = this.modalMode === 'copy' ? '复制成功' : '新建成功';
        this.$message.success(message);
        this.getList();
      }
      this.oemCreateVisible = false
    },
    
    /**
     * 清空选择状态
     */
    cleanSelect() {
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    
    /**
     * 获取配方类型文本
     * @param {number} formulaType - 配方类型代码
     * @returns {string} 配方类型文本
     */
    getFormulaTypeText(formulaType) {
      const typeMap = {
        1: '配合饲料',
        2: '混合日粮',
        4: '定制料',
        5: '代工配方'
      }
      return typeMap[formulaType] || formulaType
    },

    /**
     * 获取选中配方的名称列表
     * @returns {string} 选中的配方名称，用逗号分隔
     */
    getSelectedFormulaNames() {
      if (this.selectedRows.length === 0) {
        return '未选择配方';
      }
      return this.selectedRows.map(row => row.formulaName).join('、');
    }
  }
}
</script>

<style lang="scss" scoped>
.container-block {
  background: #fff;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.editBox {
  background-color: #fff;
  border-radius: 5px 5px 0 0;
  padding: 20px 20px 0 20px;
}

.editBox .ant-btn {
  margin-right: 8px;
}

.tableBox {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
}

.enable {
  background: #02830f;
  color: #fff;
  border: none;

  &:hover {
    background: #14811f;
  }
}

.forbidden {
  background: #f59a23;
  color: #fff;
  border: none;

  &:hover {
    background: #f7ab47;
  }
}
</style>